import {Box} from '@mui/material';

import {ChatBasedTalentSurveyPageFooter} from '../../../components/ChatBasedTalentSurvey/ChatBasedTalentSurveyPageFooter';
import {ChatBasedTalentSurveyPageHeader} from '../../../components/ChatBasedTalentSurvey/ChatBasedTalentSurveyPageHeader';
import {CultureAgentChat} from '../../../components/ChatBasedTalentSurvey/CultureAgentChat';

export const ChatBasedTalentSurveyPage = () => (
  <Box sx={{display: 'flex', flexDirection: 'column', gap: 4, pb: 6}}>
    <ChatBasedTalentSurveyPageHeader />
    <CultureAgentChat />
    <ChatBasedTalentSurveyPageFooter />
  </Box>
);
